import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-864cff9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PortalLoader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 298 413"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M297 412H1V149C1 67.26 67.26 1 149 1s148 66.26 148 148v263Z",
    opacity: ".1"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M297 412H1V149C1 67.26 67.26 1 149 1s148 66.26 148 148v263Z",
    pathLength: "1"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}